import { ink } from "@styles";
import { FC } from "react";
import styled from "styled-components";

interface ArrowIconProps {
  color?: string;
  rotate?: boolean;
}

const ArrowIcon: FC<ArrowIconProps> = ({ color = ink.inkBase, rotate = false }) => {
  return (
    <StyledArrowIcon xmlns="http://www.w3.org/2000/svg" $rotate={rotate}>
      <ArrowPath d="M4 8l8 8 8-8" color={color} />
    </StyledArrowIcon>
  );
};

export default ArrowIcon;

const StyledArrowIcon = styled.svg<{ $rotate: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  fill: none;
  ${(p) => p.$rotate && "transform: rotate(180deg);"}
  transition: transform 0.4s ease;
`;

const ArrowPath = styled.path<{ color: string }>`
  stroke: ${(p) => p.color};
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
